export const X_TOTAL_COUNT = 'X-Total-Count';
export const RATE_LIMIT_RESET = 'RateLimit-Reset';
export const RATE_LIMIT_HITS_REMAINING = 'RateLimit-Remaining';
export const RATE_LIMIT_MAX_HITS = 'RateLimit-Limit';
